import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '../../common/guard/auth.guard';
import { CoachSettingsComponent } from './coach-settings/coach-settings.component';
import { CoacheeSettingsComponent } from './coachee-settings/coachee-settings.component';

const routes: Routes = [
	{
		path: 'coach/tab/:tab',
		canActivate: [AuthGuard],
		component: CoachSettingsComponent,
		data: { showTitle: false, contextualChat: false },
	},
	{
		path: 'coachee',
		canActivate: [AuthGuard],
		component: CoacheeSettingsComponent,
		data: { showTitle: false, contextualChat: false },
	},
	{
		path: 'coach',
		canActivate: [AuthGuard],
		component: CoachSettingsComponent,
		data: { showTitle: false, contextualChat: false },
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class SettingsRoutingModule {}
